export const FETCH_PAGINATE_FORMULAS_REQUEST = 'formulas/FETCH_PAGINATE_FORMULAS_REQUEST';
export const FETCH_PAGINATE_FORMULAS_SUCCESS = 'formulas/FETCH_PAGINATE_FORMULAS_SUCCESS';
export const FETCH_PAGINATE_FORMULAS_FAILURE = 'formulas/FETCH_PAGINATE_FORMULAS_FAILURE';
export const SET_PAGE = 'formulas/SET_PAGE';
export const SET_LOADING = 'formulas/SET_LOADING';
